import { render, staticRenderFns } from "./FormContato.vue?vue&type=template&id=5cb73908&scoped=true&"
import script from "./FormContato.vue?vue&type=script&lang=js&"
export * from "./FormContato.vue?vue&type=script&lang=js&"
import style0 from "./FormContato.vue?vue&type=style&index=0&id=5cb73908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb73908",
  null
  
)

export default component.exports